import { createContext } from 'react'
import { ZoomMakerFile } from '../types'

type ZoomMakerWelcomeContextProps = {
    onError: (error: string) => void
    onFileAccepted: (files: ZoomMakerFile[]) => void
    onPreviewReady: (files: ZoomMakerFile[]) => void
}

export const ZoomMakerWelcomeContext = createContext({} as ZoomMakerWelcomeContextProps)
